var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowcaseImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 578.338,
    height: 415.623,
    viewBox: "0 0 578.338 415.623",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    d: "M400.131,228h29.441a16.7,16.7,0,0,1,16.7,17.08L444.8,310.31h-58.84l7.876-49.342L375,283.99a8.161,8.161,0,0,1-12.087.6h0a8.161,8.161,0,0,1-1.009-10.315L388.895,234A13.526,13.526,0,0,1,400.131,228Z",
    fill: "#7bd0a9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(-8.469 -29.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M545.488,367.48H42.224V67.471H545.488Zm-502.57-.7H544.793V68.166H42.918Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M0,0H502.57V20.688H0Z",
    transform: "translate(69.121 404.899)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 502.569,
    height: 7.515,
    transform: "translate(69.121 389.506)",
    fill: "#e6e6dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 502.569,
    height: 7.515,
    transform: "translate(69.121 372.699)",
    fill: "#e6e6dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 502.569,
    height: 7.515,
    transform: "translate(69.121 355.892)",
    fill: "#e6e6dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 502.569,
    height: 7.515,
    transform: "translate(69.121 339.084)",
    fill: "#e6e6dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M0,0H147.178V147.178H0Z",
    transform: "translate(250.888 34.639)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M505.393,382.8c.077-.1-.08.1,0,0a51.094,51.094,0,0,1,9.707-.826,55.211,55.211,0,0,1,9.541.885c.109.138-.1-.143,0,0a55.8,55.8,0,0,1-9.541.536C510.214,383.4,506.161,383.14,505.393,382.8Z",
    fill: "#493e3a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M504.126,358.452c.417.306,6.736,16.055,7.664,20.965.766,4.059,2.11,13.772,2.11,13.772l-1.143-.052s-2.557-15.05-3.38-19.055c-1.177-5.729-6.059-15.991-6.059-15.991Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M504.126,358.452s3.2-1.217,3.633-2.774-4.324-.98-5.771-2.261-2.732-1.41-5.73-1.614-5.678-.54-7.353.1a3.661,3.661,0,0,1,1.935.764c2.972,2.6,6.767,2.457,8.921,3.732A40,40,0,0,0,504.126,358.452Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M525.192,369.49c-.416.306-6.736,16.054-7.663,20.965-.768,4.058-2.111,13.772-2.111,13.772l1.144-.051s2.557-15.051,3.379-19.056c1.179-5.73,6.06-15.992,6.06-15.992Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M525.192,369.49s-3.205-1.218-3.632-2.774,4.324-.981,5.771-2.262,2.731-1.41,5.73-1.614,5.678-.539,7.353.1a3.67,3.67,0,0,0-1.935.764c-2.973,2.605-6.767,2.457-8.921,3.733A40.1,40.1,0,0,1,525.192,369.49Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M518.383,390.668c-.346-3.736-2.217-15.66-1.727-26.271.257-5.606,3.792-24.333,5.668-28.469A48.956,48.956,0,0,1,525,330.689c.117-.369,1.767-1.32.767.411s-5.05,7.874-7.743,30.894c-1.3,11.119,2.464,36.28,2.72,36.807s-1.181.976-1.181.976C518.77,393.663,518.693,394.019,518.383,390.668Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M526.311,330.689s6.9-9.078,13.791-12.985,14.022-5.656,16.089-9.954-4.6-1.1-7.124-.4a68.329,68.329,0,0,1-9.424,1.424c-3.792.445-14.738,4.937-16.09,10.369C522.39,323.817,523.094,328.506,526.311,330.689Z",
    fill: "#7bd0a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M523.241,320.671s-3.423,6.383-1.785,9.407,3.923,1.751,3.923,1.751l.932-1.14S522.592,328.292,523.241,320.671Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M521.285,310.733l-2.651,4.374s-5.777-1.855-5.777-4.374-.717-1.722-1.645-2.252-.8-2.254,0-3.579-.63-1.558-1.293-2.22-2.783-5.467,5.6-8.118c3.565-1.129,3.38-.266,4.44,0S516.646,303.179,521.285,310.733Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M521.948,310.733s-3.711-.8-3.181-3.047.663-4.11-.8-5.568.928-9.411,3.976-12.459,10.736-6.878,13.386-9.005,5.833-2.7,9.278-4.338,10.339-7.068,10.472-10.117,2.253,4.861-2.916,10.117-18.291,15.6-20.279,18.91S523.14,306.89,521.948,310.733Z",
    fill: "#7bd0a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M522.282,309.855s-4.831,8.433-7.045,38.654c-.65,8.857,1.827,34.625,1.827,34.625l-1.449-.009S513.508,357,514.3,348.046s3.71-31.08,4.331-32.939A11.776,11.776,0,0,1,522.282,309.855Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M504.637,345.16l2.5,2.981s4.129-2.068,3.835-3.962.339-1.378.976-1.885.336-1.788-.416-2.692.292-1.245.713-1.82,1.458-4.437-5.157-5.454c-2.812-.433-2.572.194-3.339.516S507.247,338.938,504.637,345.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M504.139,345.237s2.7-1.03,2.037-2.663-.976-3.013-.05-4.279-1.792-6.97-4.438-8.908-8.876-3.924-11.117-5.216-4.7-1.353-7.483-2.182-8.6-4.114-9.051-6.39-1.129,3.917,3.37,7.269,15.57,9.6,17.451,11.862S502.8,342.485,504.139,345.237Z",
    fill: "#7bd0a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M503.785,344.615s4.613,5.78,9.8,28.251c1.52,6.587,2.655,26.254,2.655,26.254l1.088-.175s-1.455-19.9-3.095-26.535-6.405-22.943-7.088-24.269A8.966,8.966,0,0,0,503.785,344.615Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M501.383,323.839s6.283,12.441,8.2,23.623,5.765,43.685,5.674,46.069,1.576-.193,1.576-.193-4.955-42.783-7.326-51.511a107.871,107.871,0,0,0-7.082-18.117Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M485.624,299.28s9.954,3.589,11.108,5.218,4.55,5.975,5.271,7.978,3.231,1.838,4.021,2.337,1.288,5.018,2.053,6.657,1.318,3.05,1.038,4.326-2.651,2.92-3.561,2.2-10.332-14.293-14.207-15.985-7.48-1.915-8.786-5.031C481.734,305.013,484.3,300.452,485.624,299.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M485.689,299.822s7.765,10.621,11.515,15.069a116.005,116.005,0,0,1,7.547,10.389s-10.928-14.318-11.761-15.266S486.506,300.893,485.689,299.822Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M503.349,328.537s1.881.353,2.508-.98-1.483-4.79-2.565-5.73-1.063-3.178-1.371-3.593c-.626-.846-8.784-4.175-8.67-5.781s-5.244-2.141-8.031-2.782c-1.258-.289,5.218,2.233,9.175,6.337C497.356,319.077,501.454,322.224,503.349,328.537Z",
    fill: "#7bd0a9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M525.534,347.458c-2.508,6.429-10.561,40.515-10.608,42.709s-2.355.986-2.355.986,10.625-42.093,12.618-44.839C528.852,341.267,526.551,344.849,525.534,347.458Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M531.3,349.933s-3.958.7-5.577-2.334-1.477-4.062-1.123-4.858-1.26-2.357-1.26-2.357a7.315,7.315,0,0,1,1.6-5.274c1.991-2.275,2.584-1.812,3.784-2.973s2.851-5.643,6.908-6.364a2.415,2.415,0,0,1,1.439.26,9.941,9.941,0,0,1,5-2.322c3.568-.78,3.922-1.576,5.126-2.565s2.862-1.113,3.441-2.462.866,5.012-.449,6.927-3.04,3.877-3.434,5.733c-.438,2.055-1.453,4.275-2.588,5.209-.3.246-4.622,2.54-5.982,5.345C536.862,344.611,535.659,348.148,531.3,349.933Z",
    fill: "#7bd0a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M549.264,321.856s-22.748,19.06-24.084,24.676l.539,1.067a19.147,19.147,0,0,1,3.79-6.222C536.066,334.252,545.428,325.753,549.264,321.856Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M505.649,382.9a60.62,60.62,0,0,0,9.373.5,55.6,55.6,0,0,0,9.526-.537c1.732,2.39-.789,6.267-.789,9.584,0,5.387.818,9.223-3.18,11.529l.01.005a11.718,11.718,0,0,1-2.042.923C511.056,400.781,507.541,391.439,505.649,382.9Z",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M505.494,382.858c.045.013.1.025.155.038,1.892,8.543,5.407,17.885,12.9,22-.094.032-.187.067-.283.1h-6.485a11.638,11.638,0,0,1-2.325-1.02l.009-.005c-4-2.306-3.179-6.142-3.179-11.529C506.284,389.125,503.763,385.248,505.494,382.858Z",
    fill: "#1a1a1a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M177.272,300.932s-13.568,3.619-19.033,16.1-3.162,21.345-1.31,24.3,2.344,12.775.276,18.314a63.025,63.025,0,0,0,2.215-18.314c-.147-10.931,4.176-10.931,6.631-19.055a89.3,89.3,0,0,1,6.664-15.878c.22-.3,3.4-3.988,3.4-3.988Z",
    fill: "#7bd0a9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M146.479,336.455s.443-28.58,22.821-39.879c0,0-5.4,10.3-6.245,17.613s-6.606,13.4-8.821,16.063S146.479,336.455,146.479,336.455Z",
    fill: "#7bd0a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M159.12,309.7a49.032,49.032,0,0,0-2.45,5.2c-.788,1.951-1.54,4.067-2.215,6.2-.659,2.145-1.251,4.307-1.756,6.347-.48,1.935-.854,3.758-1.163,5.349.109-.087.217-.176.322-.264.336-1.506.75-3.192,1.215-4.991.521-2.029,1.129-4.18,1.805-6.309a73.5,73.5,0,0,1,4.463-11.419,30.725,30.725,0,0,1,2.052-3.484c.559-.8.927-1.226.927-1.226s-.387.406-.987,1.182A26.545,26.545,0,0,0,159.12,309.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M134.555,306.021c.191.53.38,1.064.558,1.605a1.588,1.588,0,0,1,.39-.049,1.532,1.532,0,0,1,.471,2.975,27.059,27.059,0,0,1,.7,3.637c.847,7.312,6.608,13.4,8.822,16.063s7.756,6.2,7.756,6.2-.443-28.58-22.82-39.879c0,0,1.573,3.005,3.155,6.921A1.561,1.561,0,0,1,134.555,306.021Zm4.493,5.875c1.955,0,2.011,3.036.053,3.036S137.089,311.9,139.048,311.9Z",
    fill: "#7bd0a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M140.612,309.7a49.214,49.214,0,0,1,2.452,5.2c.787,1.951,1.537,4.067,2.215,6.2.657,2.145,1.248,4.307,1.755,6.347.481,1.935.854,3.758,1.162,5.349-.108-.087-.214-.176-.322-.264-.334-1.506-.75-3.192-1.213-4.991-.522-2.029-1.129-4.18-1.8-6.309a73.594,73.594,0,0,0-4.464-11.419,31.031,31.031,0,0,0-2.052-3.484c-.56-.8-.926-1.226-.926-1.226s.386.406.986,1.182A26.448,26.448,0,0,1,140.612,309.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M156.319,396.424s-3.1-14.919-3.545-17.282-.813-11.521-4.283-12.333-6.979,2.936-6.979,2.936,8.42,2.437,10.689,9.25,3.657,17.429,3.657,17.429Z",
    fill: "#7bd0a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M123.4,373.456a17.627,17.627,0,0,1,3.758-4.357,1.55,1.55,0,0,0,1.088.446h.111A1.529,1.529,0,0,0,129.845,368a1.475,1.475,0,0,0-.144-.61c2.243-1.179,4.14-1.387,4.757-1.155a22.314,22.314,0,0,0,8.605.277,10.788,10.788,0,0,1,5.428.3,72.06,72.06,0,0,1-6.979,2.936c-1.136.192-4.763,1.717-9.361,5.649s-12.74,14.124-13.736,14.291S119.356,379.992,123.4,373.456Z",
    fill: "#7bd0a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M137.316,366.711c.466.049.34.029.875.053-5.192,1.486-16.048,6.367-19.5,21.591A28.128,28.128,0,0,1,137.316,366.711Z",
    fill: "#7bd0a9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M157.889,396.424s3.1-14.919,3.545-17.282.812-11.521,4.283-12.333,6.979,2.936,6.979,2.936-8.42,2.437-10.69,9.25-3.656,17.429-3.656,17.429Z",
    fill: "#7bd0a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M165.717,366.809a10.788,10.788,0,0,1,5.428-.3,22.307,22.307,0,0,0,8.6-.277c1.181-.442,7.015.684,11.059,7.22s5.983,16.4,4.986,16.229-9.14-10.358-13.737-14.291-8.226-5.457-9.361-5.649A72.168,72.168,0,0,1,165.717,366.809Z",
    fill: "#7bd0a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M176.892,366.711c-.466.049-.34.029-.874.053,5.191,1.486,16.047,6.367,19.5,21.591A28.132,28.132,0,0,0,176.892,366.711Z",
    fill: "#7bd0a9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M110.531,338.819s7.975-5.909,16.542-.369c1.133.733,2.139,1.438,3.059,2.123a1.341,1.341,0,0,1,1.271-.76,1.555,1.555,0,0,1,1.083,2.622c.4.337.793.673,1.169,1a1.462,1.462,0,0,1,.74-.189,1.527,1.527,0,0,1,1.393,2.118,45.952,45.952,0,0,0,9.6,7.264c8.2,4.577,8.789,13.809,8.789,17.945s1.846,7.46,1.625,10.192.516,15.657.516,15.657h.886s.149-31.527-.886-33.636a158.63,158.63,0,0,1-5.908-17.026,17.019,17.019,0,0,1-.517-5.614,12.879,12.879,0,0,0-9.157-6.572c-6.8-1.33-9.159-2.069-11.449-3.546S114.74,327.593,110.531,338.819ZM139.6,342.25c1.955,0,2.011,3.033.053,3.033S137.644,342.25,139.6,342.25Z",
    fill: "#7bd0a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M126.34,334.43a23.453,23.453,0,0,1,2.411.317c.875.172,1.818.38,2.8.661s2.005.617,3.048,1.01,2.1.852,3.16,1.348,2.114,1.042,3.149,1.626a71.268,71.268,0,0,1,9.557,6.6c.016.069.034.138.051.211a70.7,70.7,0,0,0-9.717-6.613c-1.026-.589-2.077-1.132-3.124-1.645s-2.1-.964-3.136-1.367-2.051-.746-3.028-1.03-1.914-.5-2.782-.68c-.876-.155-1.678-.286-2.4-.355-.718-.1-1.349-.09-1.865-.131-1.036,0-1.63.013-1.63.013s.591-.031,1.63-.05C124.987,334.37,125.62,334.346,126.34,334.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M153.938,394.974h.887s.739-12.923.517-15.656,1.624-6.056,1.624-10.192.592-13.367,8.79-17.946,9.748-8.641,18.315-14.18,16.543.37,16.543.37c-3-8-10.091-9.811-14.745-9.655a1.483,1.483,0,1,1-2.79.379,4.455,4.455,0,0,0-1.222.487c-2.291,1.477-4.653,2.216-11.449,3.545a12.879,12.879,0,0,0-9.157,6.572,17.025,17.025,0,0,1-.516,5.613,159.235,159.235,0,0,1-5.91,17.028C153.791,363.449,153.938,394.974,153.938,394.974Zm17.569-62.99c1.954,0,2.011,3.035.052,3.035S169.547,331.984,171.507,331.984Z",
    fill: "#7bd0a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M184.8,332.98a23.963,23.963,0,0,0-2.411.318c-.876.172-1.818.38-2.8.661s-2.006.619-3.049,1.011-2.1.851-3.158,1.346-2.115,1.043-3.151,1.627a70.956,70.956,0,0,0-9.557,6.6c-.015.067-.032.136-.052.209a70.952,70.952,0,0,1,9.718-6.613c1.027-.589,2.08-1.131,3.126-1.645s2.1-.961,3.134-1.365,2.052-.747,3.028-1.031,1.914-.5,2.784-.68c.873-.155,1.676-.287,2.4-.355.717-.1,1.348-.091,1.864-.131,1.036,0,1.63.012,1.63.012s-.592-.03-1.63-.05C186.157,332.922,185.524,332.9,184.8,332.98Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M140.9,321.5a18.027,18.027,0,0,0-7.252-1.623c-3.877.037-5.1-1.145-6.352-1.662s-12.3,1-18.795,9.49a54.855,54.855,0,0,1,18.573-5.428c10.523-1.071,9.122-.443,9.122-.443l3.322.812Z",
    fill: "#7bd0a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M157.205,396.424s-.148-28.359,0-36.779-3.1-25.4-5.022-30.279-14.1-11.89-25.11-7.09c0,0,6.795.074,8.568,2.141s6.129,7.386,8.641,9.232,3.618,14.032,6.72,20.236,5.022,8.936,5.317,14.032.508,28.507.508,28.507Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M185.767,300.453s-10.246-1.662-15.231,4.652-17.009,21.935-13.322,31.35-.009,23.19-.009,23.19,3.8-7.475,3.361-19.376,6.2-13.34,11.189-25.747S180.171,301.006,185.767,300.453Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M157.889,356.489l-.2,39.935H157.2l.047-36.961Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M153.255,367.768s-.62,3.694,1.573,11v17.652h.532V379.216s2.489-5.686,5.638-6.942C161,372.274,155.138,368.065,153.255,367.768Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M160.3,371.534s-.618-8.021,2.1-10.882,10.033-3.689,12.913-10.426a53.933,53.933,0,0,1,6.149-10.937s-14.828,3.371-19.062,10.937-3.2,21.308-3.2,21.308Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M172.022,342.585s8.928-3.592,15.671-1.345,7.764-1.951,7.764-1.951-.408,1.134-7.457-.5A17.961,17.961,0,0,0,172.022,342.585Z",
    fill: "#7bd0a9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M145.85,389.191l.009,0c-.98,11.379,6.948,19.371,16.654,23.1a12.566,12.566,0,0,1-2.536,1.113h-7.3c-5.709-1.784-9.9-7.645-9.9-14.6A16.247,16.247,0,0,1,145.85,389.191Z",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M145.842,389.194c.857.367,5.266.646,10.581.646a60.84,60.84,0,0,0,10.41-.586,16.255,16.255,0,0,1,3.025,9.55,15.45,15.45,0,0,1-7.363,13.49C152.788,408.565,144.861,400.573,145.842,389.194Z",
    fill: "#1a1a1a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M163.561,366.159a22.542,22.542,0,0,1-10.3,1.617s12.854,5.022,12.8,35.6C166.054,403.373,173.532,384.333,163.561,366.159Z",
    fill: "#7bd0a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M160.04,367.274c.1.146.2.283.3.435.43.613.831,1.318,1.282,2.05.4.758.881,1.532,1.253,2.392.2.424.4.856.606,1.292q.27.672.545,1.359c.391.9.666,1.866.991,2.813.307.951.507,1.934.759,2.885.21.961.356,1.92.531,2.839.144.925.2,1.832.294,2.684.115.851.075,1.667.111,2.415a19.518,19.518,0,0,1,0,2.04c-.037.605-.068,1.134-.094,1.569-.054.869-.084,1.366-.084,1.366s0-.5.009-1.369c0-.435.006-.963.009-1.568.027-.605-.063-1.286-.09-2.029-.058-.742-.044-1.551-.183-2.394-.119-.843-.208-1.737-.354-2.653-.18-.911-.335-1.858-.553-2.807-.26-.939-.466-1.909-.778-2.848s-.577-1.9-.955-2.795c-.176-.454-.352-.9-.525-1.349q-.3-.653-.585-1.287c-.371-.852-.812-1.633-1.189-2.4-.424-.737-.8-1.451-1.211-2.072-.113-.179-.22-.344-.329-.515C159.885,367.312,159.962,367.292,160.04,367.274Z",
    fill: "#7bd0a9"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M463.547,36.767a7.066,7.066,0,0,0-.969,3.1,12.556,12.556,0,0,1-.4,2.384l-20.9-12.347-12.347,20.9a12.483,12.483,0,0,0,2.385.4,7.11,7.11,0,1,1-6.556,10.833,10.43,10.43,0,0,0-1.4-1.794L411.671,80.022l50.116,29.6,29.6-50.116L471.616,47.829a10.383,10.383,0,0,1,1.794-1.4,7.108,7.108,0,1,0-9.863-9.658Z",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M415.47,124.062l-3.488,12.817a8.771,8.771,0,0,0,7.235,10.988l7.344,1.039,7.818,7.7,9.5-9.961L433.62,124Z",
    fill: "#ed9c98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M426.067,121.058a6.95,6.95,0,1,1-6.95-6.949A6.95,6.95,0,0,1,426.067,121.058Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M421.25,114.445s7.8.366,25.638,6.613c0,0,18.649,10.3,29.536-.819,0,0,12.394-13.667,22.586-9.034,0,0,12.046,2.78,9.151,20.27,0,0-3.128,16.91-28.146,13.667l-43.782-3.748h0l-7.3-3.2-.983-.433a15.022,15.022,0,0,1-8.835-11.729h0Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M425.807,139.3h0a3.41,3.41,0,0,0,4.658-1.248l.525-.908a3.412,3.412,0,0,0-1.249-4.659h0a3.41,3.41,0,0,0-4.658,1.248l-.525.909A3.41,3.41,0,0,0,425.807,139.3Z",
    fill: "#ed9c98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M510.13,223.287l59.766,74.63,3.012,9.035,1.158,11.119,7.181-9.961-1.6-9.221,5.077,3.893,2.085-2.548-5.084-6.609a9.143,9.143,0,0,0-4.816-3.24h0a9.146,9.146,0,0,1-5.621-4.48l-24.02-44.61a22.072,22.072,0,0,0-9.57-9.281h0l-6.949-19.043Z",
    fill: "#ed9c98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M531.793,215.837h0l-1.046-2.866L510.13,223.287l4.58,5.72h0S525.244,225.417,531.793,215.837Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M466.579,226.8l-6.83,8.672a9.542,9.542,0,0,0,3.813,14.705l50.969,21.332,6.486,8.8,3.707,10.425,3.243-12.046-3.706-7.645,6.254,2.085.811-2.78L527,267.029a14.215,14.215,0,0,0-7.081-2.85h0a14.207,14.207,0,0,1-6.995-2.784l-26.081-19.7a10.364,10.364,0,0,0-6.247-2.095h0L493.277,228Z",
    fill: "#ed9c98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M463.167,231.132s16.83,3.919,25.732.873h0l1.328-1.214c-.129-.9-2.044-2-4.868-3.146l-18.78-.845-3.412,4.332Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M579.645,298.889l5.077,3.893,2.085-2.548-5.084-6.609a9.127,9.127,0,0,0-3.086-2.559l-1.142,2.284a11,11,0,0,0-1.163,4.924v1.468a11.964,11.964,0,0,1-3.241,8.188l-.073.078,1.048,10.063,7.181-9.961Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M524.261,271.045l6.254,2.085.811-2.78L527,267.029a14.2,14.2,0,0,0-4.337-2.263l-.427,1.139a11.387,11.387,0,0,0-.412,6.628h0a11.387,11.387,0,0,1-.311,6.348l-.494,1.43,3.707,10.425,3.243-12.046Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M366.732,217.777a7.066,7.066,0,0,0,1.847,2.673,12.561,12.561,0,0,1,1.634,1.783l-22.6,8.876,8.876,22.6a12.493,12.493,0,0,0,1.783-1.633,7.111,7.111,0,0,1,12.152,2.976,7.106,7.106,0,0,1-7.648,8.858,10.451,10.451,0,0,0-2.278,0l8.4,21.377L423.077,264l-21.283-54.176-21.378,8.4a10.453,10.453,0,0,1,0-2.278,7.108,7.108,0,1,0-13.681,1.831Z",
    fill: "#185abc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M270.669,237.414l1.894-1.981a.8.8,0,0,1,1.375.533l.043,1.894,3.667,1a3.084,3.084,0,0,1-.742,6.058l-5.89.133-9.683,7.655-4.383-8.553Z",
    fill: "#ed9c98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M303.123,193.076a7.052,7.052,0,0,0,.1,3.247,12.554,12.554,0,0,1,.4,2.384l-23.8-4.792-4.793,23.8a12.549,12.549,0,0,0,2.385-.4,7.109,7.109,0,0,1,8.6,9.089,7.106,7.106,0,0,1-11.229,3.3,10.432,10.432,0,0,0-1.916-1.233l-4.534,22.516L325.4,262.467l11.491-57.061-22.516-4.534a10.4,10.4,0,0,1,1.233-1.916,7.108,7.108,0,1,0-12.488-5.88Z",
    fill: "#b31412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M227.262,129.848a7.064,7.064,0,0,0-3.163.742,12.522,12.522,0,0,1-2.257.868V107.182H197.566a12.5,12.5,0,0,0,.868,2.257,7.11,7.11,0,0,1-7.213,10.222,7.105,7.105,0,0,1-5.448-10.358,10.394,10.394,0,0,0,.83-2.121H163.635v58.207h58.207V142.421a10.417,10.417,0,0,1,2.121.83,7.108,7.108,0,1,0,3.3-13.4Z",
    fill: "#ea8600"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M329.928,130.921a7.064,7.064,0,0,0-3.163.742,12.524,12.524,0,0,1-2.257.868V108.255H300.232a12.523,12.523,0,0,0,.868,2.257,7.11,7.11,0,0,1-7.213,10.222,7.1,7.1,0,0,1-5.448-10.357,10.425,10.425,0,0,0,.83-2.122H266.3v58.207h58.207V143.494a10.394,10.394,0,0,1,2.121.83,7.108,7.108,0,1,0,3.3-13.4Z",
    fill: "#e94335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M347.111,102.835a7.065,7.065,0,0,0,.743,3.163,12.522,12.522,0,0,1,.868,2.257H324.446v24.276a12.524,12.524,0,0,0,2.257-.868,7.11,7.11,0,0,1,10.222,7.213,7.107,7.107,0,0,1-10.358,5.448,10.4,10.4,0,0,0-2.121-.83v22.968h58.206V108.255H359.685a10.394,10.394,0,0,1,.83-2.121,7.108,7.108,0,1,0-13.4-3.3Z",
    fill: "#fbbc05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M319.026,85.536a7.07,7.07,0,0,0,3.163-.742,12.494,12.494,0,0,1,2.257-.868V108.2h24.276a12.522,12.522,0,0,0-.868-2.257,7.11,7.11,0,0,1,7.213-10.222,7.107,7.107,0,0,1,5.448,10.358,10.394,10.394,0,0,0-.83,2.121h22.967V49.995H324.446V72.963a10.426,10.426,0,0,1-2.122-.83,7.108,7.108,0,1,0-3.3,13.4Z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M301.842,113.622a7.07,7.07,0,0,0-.742-3.163,12.523,12.523,0,0,1-.868-2.257h24.276V83.926a12.494,12.494,0,0,0-2.257.868,7.11,7.11,0,0,1-10.222-7.213,7.106,7.106,0,0,1,10.357-5.448,10.426,10.426,0,0,0,2.122.83V49.995H266.3V108.2h22.968a10.394,10.394,0,0,1-.83,2.121,7.108,7.108,0,1,0,13.4,3.3Z",
    fill: "#4285f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M58.134,323.381l-21.958,4.731,6.408,28.707h0a7.6,7.6,0,0,0,3.54-7.089l-.69-8.046a6.479,6.479,0,0,1,6.241-7.027c4.779-.161,10.282-.47,10.1-1.044C61.459,332.605,58.134,323.381,58.134,323.381Z",
    fill: "#ed9c98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M36.176,328.112l6.408,28.707a7.6,7.6,0,0,0,3.54-7.089l-.69-8.046a6.432,6.432,0,0,1,.4-2.832l-.482-.272a7.528,7.528,0,0,1-3.755-5.447l-.9-5.995Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M38.622,278.1l-21.392-6.85L8.469,299.324h0a7.6,7.6,0,0,0,6.6-4.379l3.415-7.318a6.478,6.478,0,0,1,8.914-2.979c4.222,2.244,9.146,4.72,9.276,4.133C36.9,287.749,38.622,278.1,38.622,278.1Z",
    fill: "#ed9c98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M17.23,271.246,8.469,299.324a7.6,7.6,0,0,0,6.6-4.379l3.415-7.318a6.427,6.427,0,0,1,1.756-2.257l-.283-.476a7.526,7.526,0,0,1-.537-6.593l2.212-5.644Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M201.733,139.413l.228-2.731a.8.8,0,0,1,1.406-.449l1.223,1.446,3.482-1.526a3.084,3.084,0,0,1,3.23,5.179l-4.5,3.8-2.722,12.039-8.784-3.9Z",
    fill: "#ed9c98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M322.791,242.626l1.894-1.981a.8.8,0,0,1,1.375.534l.043,1.894,3.667,1a3.084,3.084,0,0,1-.742,6.058l-5.891.134-9.682,7.654-4.383-8.553Z",
    fill: "#ed9c98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M446.57,71.939l-.122-2.738a.8.8,0,0,1,1.337-.624l1.4,1.279,3.258-1.957a3.084,3.084,0,0,1,3.863,4.725l-3.977,4.347-1.956,11.78-8.419-2.241Z",
    fill: "#ed9c98"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M275.067,418.047a5.494,5.494,0,0,1,.913-4.85l9.09-11.9-8.813-4.785-13,23.936,3.066,1.664.889-1.638,7.956,7.719a1.445,1.445,0,0,0,2.4-1.436Z",
    fill: "#ed9c98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M275.115,418.215h0l2.429,8.454a1.447,1.447,0,0,1-2.372,1.52l-7.956-7.719-.889,1.638-3.066-1.664,4.181-7.7,4.238,5.713A2.042,2.042,0,0,0,275.115,418.215Z",
    fill: "#4117ab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M234.438,407a5.492,5.492,0,0,1,2.028-4.5l11.631-9.434-7.441-6.722L222.4,406.553l2.588,2.338,1.249-1.382,5.921,9.372a1.424,1.424,0,0,0,.253.3,1.445,1.445,0,0,0,2.412-1.134Z",
    fill: "#ed9c98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M234.445,407.172h0l.375,8.788a1.447,1.447,0,0,1-2.662.921l-5.921-9.372-1.249,1.382-2.588-2.338,5.873-6.5,2.777,6.55A2.042,2.042,0,0,0,234.445,407.172Z",
    fill: "#4117ab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    d: "M8.373,0H13.23a12,12,0,0,1,12,12v2.5a12,12,0,0,1-12,12H12a12,12,0,0,1-12-12V8.373A8.373,8.373,0,0,1,8.373,0Z",
    transform: "translate(422.459 224.081) rotate(-170.636)",
    fill: "#ed9c98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M409.1,229.007l-.818-11.531h12.209l2.172,11.531Z",
    fill: "#ed9c98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M401,199.983a7.642,7.642,0,0,1,8.392-4.915l9.864,1.627a7.639,7.639,0,0,1,6.276,8.754l-2.207,13.388a5.332,5.332,0,0,1-6.109,4.38h0a8.717,8.717,0,0,1-6.515-4.993l-1.529-3.366a25.89,25.89,0,0,1-2.32-10.712h0A11.344,11.344,0,0,1,401,199.983Z",
    fill: "#4117ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M407.649,215.954h0a2.994,2.994,0,0,0,4.078-1.092l.459-.8a2.994,2.994,0,0,0-1.093-4.078h0a2.994,2.994,0,0,0-4.078,1.093l-.459.8A2.994,2.994,0,0,0,407.649,215.954Z",
    fill: "#ed9c98"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M134.691,105.676H126.4a.348.348,0,0,1,0-.695h8.294a.348.348,0,1,1,0,.695Z",
    fill: "#e2dcd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M130.544,109.823a.347.347,0,0,1-.347-.347v-8.294a.347.347,0,1,1,.695,0v8.294A.347.347,0,0,1,130.544,109.823Z",
    fill: "#e2dcd2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M137.519,100.054a1.482,1.482,0,1,1-1.482-1.482A1.482,1.482,0,0,1,137.519,100.054Z",
    fill: "#e2dcd2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M418.952,104.945A3.039,3.039,0,1,1,416.4,108.4,3.039,3.039,0,0,1,418.952,104.945Z",
    fill: "#e2dcd2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 7.003,
    cy: 7.003,
    r: 7.003,
    transform: "matrix(0.923, -0.385, 0.385, 0.923, 400.283, 94.681)",
    fill: "#e2dcd2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M325.352,321.143a.35.35,0,0,1-.246-.1l-5.865-5.865a.348.348,0,1,1,.492-.492l5.865,5.865a.347.347,0,0,1-.246.593Z",
    fill: "#e6e6dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M319.487,321.143a.347.347,0,0,1-.246-.593l5.865-5.865a.348.348,0,1,1,.492.492l-5.865,5.865A.35.35,0,0,1,319.487,321.143Z",
    fill: "#e6e6dc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M342.576,304.388a7,7,0,1,1-7-7A7,7,0,0,1,342.576,304.388Z",
    fill: "#e6e6dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M327.414,306.081a8.507,8.507,0,1,1,8.507-8.508A8.517,8.517,0,0,1,327.414,306.081Zm0-16.32a7.813,7.813,0,1,0,7.812,7.812A7.821,7.821,0,0,0,327.414,289.761Z",
    fill: "#e6e6dc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M517.668,157.088a3.386,3.386,0,1,1,3.214-2.314h0A3.391,3.391,0,0,1,517.668,157.088Zm0-6.077a2.69,2.69,0,1,0,.85.138A2.695,2.695,0,0,0,517.672,151.011Zm2.881,3.653h0Z",
    fill: "#e6e6dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M535.026,140.739l-2.059,6.994-2.059,6.994-5.027-5.28-5.027-5.28,7.086-1.714Z",
    fill: "#e6e6dc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M87.647,193.367l-9.172,8.364L69.3,210.1l-2.658-12.125-2.658-12.125,11.83,3.761Z",
    fill: "#e6e6dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M90.587,239.656,69.179,284.6l-34.053-9.034-2.78,14.246,33.08,11.756A12.827,12.827,0,0,0,80.041,297.1l26.665-36.128-8.687,51.427-43.087,9.382,2.432,15.984,48.884-10.577a17.35,17.35,0,0,0,13.16-12.733l14.022-55.845Z",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M407.691,411.083l11.9,19.052-25.063,15.394h0a7.6,7.6,0,0,1,2.622-7.477l6.254-5.109a6.478,6.478,0,0,0,.7-9.372c-3.214-3.541-6.824-7.706-6.287-7.976C398.756,415.121,407.691,411.083,407.691,411.083Z",
    fill: "#ed9c98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M419.588,430.135l-25.063,15.394a7.6,7.6,0,0,1,2.622-7.477l6.254-5.109a6.425,6.425,0,0,0,1.757-2.257l.53.157a7.53,7.53,0,0,0,6.524-1.1l4.927-3.531Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M467.8,390.5l16.685,15.037-19.852,21.7h0a7.6,7.6,0,0,1,.46-7.91l4.6-6.634a6.479,6.479,0,0,0-1.913-9.2c-4.064-2.519-8.682-5.528-8.24-5.935C460.318,396.839,467.8,390.5,467.8,390.5Z",
    fill: "#ed9c98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M484.48,405.533l-19.852,21.7a7.6,7.6,0,0,1,.46-7.91l4.6-6.634a6.448,6.448,0,0,0,1.067-2.653l.553,0a7.524,7.524,0,0,0,5.968-2.854l3.764-4.752Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M151.034,148.926l2.288,10.415a6.1,6.1,0,0,1-3.682,6.971l-5.684,2.289-.982,14.106-14.568-4.523,4.248-15.317-4.248-8.667,10.131-6.145Z",
    fill: "#ed9c98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M147.415,140.778l.22-.147a4.449,4.449,0,0,1,5.445.389h0a4.447,4.447,0,0,1,.859,5.571l-.279.473a4.441,4.441,0,0,1-2.566,2l-11.048,3.278h0a6.962,6.962,0,0,1,.343,7.415l-.329.58-3.662-2.065-.293,4.211a4.441,4.441,0,0,1-1.655,3.16l-2.194,1.759-1.708-4.6a5.326,5.326,0,0,0-1.471-2.143l-3.989-3.522,5.085-8.523,17.242-7.837",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M140.176,142.271a3.986,3.986,0,1,0,4.254-3.7A3.987,3.987,0,0,0,140.176,142.271Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M133.858,144.4a3.986,3.986,0,1,0,4.253-3.7A3.986,3.986,0,0,0,133.858,144.4Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M127.982,147.986a3.986,3.986,0,1,0,4.253-3.7A3.986,3.986,0,0,0,127.982,147.986Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M124.078,153.471a5.743,5.743,0,1,0,6.128-5.33A5.743,5.743,0,0,0,124.078,153.471Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M138.215,163.73h0a2.674,2.674,0,0,0,1-3.636l-.406-.713a2.674,2.674,0,0,0-3.636-1h0a2.676,2.676,0,0,0-1,3.636l.406.713A2.674,2.674,0,0,0,138.215,163.73Z",
    fill: "#ed9c98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M138.478,170.122l5.478-1.522-.132,1.894Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M260.64,244.289l-22.668-2.06a13.755,13.755,0,0,0-14.59,10.363h0a48.727,48.727,0,0,0,6.374,38.307l8.3,12.809-3.474,19.673,49.689-13.071-17.026-44.477,16.061,5.354a13.221,13.221,0,0,0,11.074-1.261l26.029-15.907-6.6-7.3L289.48,258.189Z",
    fill: "#9fc2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M234.579,323.381s-4.17,15.075,12.509,24.457L264.114,359.3l-31.62,34.748,7.3,7.645,37.75-34.033A9.758,9.758,0,0,0,279.6,355.8l-8.436-15.7,19.7,24.07-19.7,38.917,8.237,7.3,28.252-41.512a16.349,16.349,0,0,0,.606-17.433l-23.993-41.13Z",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-2",
    "data-name": "SVGID",
    d: "M400.131,228h29.441a16.7,16.7,0,0,1,16.7,17.08L444.8,310.31h-58.84l7.876-49.342L375,283.99a8.161,8.161,0,0,1-12.087.6h0a8.161,8.161,0,0,1-1.009-10.315L388.895,234A13.526,13.526,0,0,1,400.131,228Z",
    fill: "#7bd0a9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 180.176,
    height: 6.255,
    transform: "matrix(0.744, 0.668, -0.668, 0.744, 392.016, 179.625)",
    fill: "#7bd0a9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 180.176,
    height: 6.255,
    transform: "translate(381.965 189.677) rotate(41.949)",
    fill: "#7bd0a9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 180.176,
    height: 6.255,
    transform: "translate(371.913 199.728) rotate(41.949)",
    fill: "#7bd0a9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 180.176,
    height: 6.255,
    transform: "translate(361.862 209.78) rotate(41.949)",
    fill: "#7bd0a9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 180.176,
    height: 6.255,
    transform: "matrix(0.744, 0.668, -0.668, 0.744, 351.81, 219.831)",
    fill: "#7bd0a9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 180.176,
    height: 6.255,
    transform: "matrix(0.744, 0.668, -0.668, 0.744, 341.758, 229.883)",
    fill: "#7bd0a9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 180.176,
    height: 6.255,
    transform: "matrix(0.744, 0.668, -0.668, 0.744, 331.707, 239.935)",
    fill: "#7bd0a9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 180.176,
    height: 6.255,
    transform: "matrix(0.744, 0.668, -0.668, 0.744, 321.655, 249.986)",
    fill: "#7bd0a9"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M390.134,310.31l-20.276,59.276a14.314,14.314,0,0,0,2.022,13.127l27.983,37.957,10.193-7.926-21.312-38.3,25.481-45.022h3.823l2.675,38.51a13.287,13.287,0,0,0,5.882,10.134l35.8,23.884,9.73-9.055L441.1,365.49V310.31Z",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M401,199.983s-7.735-7.931,2.4-14.765v5.1s.52-7.528,14.072-9.266l-3.359,7.992s2.66-4.864,11.523-3.011l-5.964,7.528a8.126,8.126,0,0,1,9.266-.579L424.3,196.8s2.637,1.771,1.029,9.862Z",
    fill: "#4117ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M443.877,146.648l-9.5,9.961,3.475,7.181.723,11.706a10.142,10.142,0,0,0,9.46,9.494l8.813.575,17.374,19.691L460.324,228s50.5,16.964,77.372-18.875l-10.5-13.565a62.664,62.664,0,0,0-44.864-24.127h0l-21.649-29.908a6.626,6.626,0,0,0-2.03-1.839h0a6.634,6.634,0,0,1-2.454-2.506l-10.7-19.259s7.181-36.833,6.254-36.833S443.645,79,443.645,79L432.994,114.85A13.131,13.131,0,0,0,433.62,124Z",
    fill: "#ffe167"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M99.873,104.024H69.989a8.363,8.363,0,0,0-8.339,8.339v13.668a8.364,8.364,0,0,0,8.339,8.339h29.9a2.245,2.245,0,0,1,2.1,1.345l6.221,14.755V112.363A8.363,8.363,0,0,0,99.873,104.024Z",
    fill: "#e6e6dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M165.082,248.106V231.931a8.364,8.364,0,0,1,8.339-8.34h13.668a8.364,8.364,0,0,1,8.339,8.34v16.19a2.245,2.245,0,0,0,1.345,2.1l14.755,6.221H173.421A8.364,8.364,0,0,1,165.082,248.106Z",
    fill: "#e6e6dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M87.248,238.382c3.2,1.56,51.426,22.586,51.426,22.586l15.984-62.2,32.66-11.081a14.237,14.237,0,0,0,8.676-8.273l9.744-24.776-10.425-4.17-11.35,24.439-30.115,4.634-24.228-6.579a13.194,13.194,0,0,0-15.431,7.192Z",
    fill: "#b31412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M211.521,247.832l58.524-3.7-.779-4.889a7.6,7.6,0,0,0-5.8-6.208h0a6.012,6.012,0,0,1-4.75-6.4h0a5.685,5.685,0,0,0-4.115-5.965h0a4.634,4.634,0,0,1-3.348-3.992l-.031-.3a9.122,9.122,0,0,0-9.592-8.188l-2.21.126a10.131,10.131,0,0,0-9.557,10.214l.008.874a6.418,6.418,0,0,1-4.473,6.179h0a5.8,5.8,0,0,0-4.027,5.943l.192,2.656a3.478,3.478,0,0,1-2.577,3.612h0a10.009,10.009,0,0,0-7.436,9.322Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M484.069,181.048H460.093a8.365,8.365,0,0,0-8.34,8.34v6.469a8.642,8.642,0,0,1-6.391,8.343l-9.129,2.463h47.836a8.364,8.364,0,0,0,8.339-8.34v-8.935A8.364,8.364,0,0,0,484.069,181.048Z",
    fill: "#e6e6dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M388.457,315.211l52.64-4.9H390.134Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M267.242,265.833l-7.448-1.067,8.642,4.391Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M234.579,323.381l49.689-13.071-50.147,16.828Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M443.877,146.648l3.483,8.862-5.408-6.843Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M98.548,113.827H70.795a1.511,1.511,0,0,1-1.506-1.506h0a1.51,1.51,0,0,1,1.506-1.5H98.548a1.509,1.509,0,0,1,1.506,1.5h0A1.51,1.51,0,0,1,98.548,113.827Z",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M74.312,116.607H70.848a1.54,1.54,0,0,0-1.5,1.1,1.51,1.51,0,0,0,1.451,1.914h3.517a1.506,1.506,0,0,0,1.506-1.5h0A1.506,1.506,0,0,0,74.312,116.607Z",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M98.5,116.607H78.486a1.506,1.506,0,0,0-1.506,1.506h0a1.506,1.506,0,0,0,1.506,1.5H98.549A1.51,1.51,0,0,0,100,117.7,1.539,1.539,0,0,0,98.5,116.607Z",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M84.672,125.41H70.795a1.511,1.511,0,0,1-1.506-1.506h0a1.511,1.511,0,0,1,1.506-1.506H84.672a1.51,1.51,0,0,1,1.505,1.506h0A1.51,1.51,0,0,1,84.672,125.41Z",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M98.548,125.41H88.753a1.51,1.51,0,0,1-1.5-1.506h0a1.51,1.51,0,0,1,1.5-1.506h9.795a1.51,1.51,0,0,1,1.506,1.506h0A1.51,1.51,0,0,1,98.548,125.41Z",
    fill: "#b2b2b2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M458.813,198.141h27.754a1.511,1.511,0,0,1,1.506,1.506h0a1.511,1.511,0,0,1-1.506,1.506H458.813a1.51,1.51,0,0,1-1.5-1.506h0A1.51,1.51,0,0,1,458.813,198.141Z",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M483.05,195.361h3.464a1.54,1.54,0,0,0,1.5-1.1,1.51,1.51,0,0,0-1.451-1.914H483.05a1.506,1.506,0,0,0-1.506,1.5h0A1.506,1.506,0,0,0,483.05,195.361Z",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M458.866,195.361h20.01a1.506,1.506,0,0,0,1.506-1.506h0a1.506,1.506,0,0,0-1.506-1.5H458.813a1.511,1.511,0,0,0-1.451,1.914A1.541,1.541,0,0,0,458.866,195.361Z",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M472.69,186.558h13.877a1.511,1.511,0,0,1,1.506,1.506h0a1.511,1.511,0,0,1-1.506,1.506H472.69a1.51,1.51,0,0,1-1.505-1.506h0A1.51,1.51,0,0,1,472.69,186.558Z",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M458.813,186.558h9.8a1.51,1.51,0,0,1,1.505,1.506h0a1.51,1.51,0,0,1-1.505,1.506h-9.8a1.51,1.51,0,0,1-1.5-1.506h0A1.51,1.51,0,0,1,458.813,186.558Z",
    fill: "#b2b2b2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M169.3,243.176h21.191A1.511,1.511,0,0,1,192,244.682h0a1.511,1.511,0,0,1-1.506,1.506H169.3a1.51,1.51,0,0,1-1.506-1.506h0A1.51,1.51,0,0,1,169.3,243.176Z",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M186.974,240.4h3.464a1.54,1.54,0,0,0,1.5-1.1,1.51,1.51,0,0,0-1.451-1.915h-3.517a1.505,1.505,0,0,0-1.505,1.506h0A1.506,1.506,0,0,0,186.974,240.4Z",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M169.352,240.4H182.8a1.506,1.506,0,0,0,1.506-1.506h0a1.506,1.506,0,0,0-1.506-1.506H169.3a1.51,1.51,0,0,0-1.45,1.915A1.54,1.54,0,0,0,169.352,240.4Z",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M183.176,231.594h7.315A1.51,1.51,0,0,1,192,233.1h0a1.51,1.51,0,0,1-1.506,1.5h-7.315a1.509,1.509,0,0,1-1.5-1.5h0A1.509,1.509,0,0,1,183.176,231.594Z",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M169.3,231.594H179.1A1.509,1.509,0,0,1,180.6,233.1h0a1.509,1.509,0,0,1-1.505,1.5H169.3a1.509,1.509,0,0,1-1.506-1.5h0A1.51,1.51,0,0,1,169.3,231.594Z",
    fill: "#b2b2b2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowcaseImage);
export default __webpack_public_path__ + "static/media/showcaseImage.4a5c74d8bfca7ac0327313c2b342cd7f.svg";
export { ForwardRef as ReactComponent };